import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import * as moment from 'moment';


export class CustomValidators {
    static numeric(control: AbstractControl): ValidationErrors | null {
    const abc =  !isNaN(control.value) ? null : { 'numeric': true };
        return !isNaN(control.value) ? null : { 'numeric': true };
    }

    static validDateOrNull(control: AbstractControl): ValidationErrors | null {
        if (control.value === null || control.value === undefined || control.value === '') {
            return null;
        }
        const m = moment(control.value, 'MM/DD/YYYY');
        return (m.isValid()) ? null : { 'validDateOrNull': true };
    }


    //Validate dates
    //Valid dates can have one or two digits for Month or Day. Must have four for year. 
    //  Some browser datepickers will show dates as MM/DD/YYYY but are actually YYYY-MM-DD so allow both.
    //  Also has to be after 01/01/1900 just so 
    static validDateFormat(control: AbstractControl): ValidationErrors | null {
        if (control.value === null || control.value === undefined || control.value === '') {
            return null;
        }
       
        var isFormatValid = moment(control.value, 'M/D/YYYY', true).isValid();
        var isFormat2Valid = moment(control.value, 'YYYY-M-D', true).isValid();
        var isAfter1900 = moment(control.value).isAfter('1900-01-01');


        return ((isFormatValid || isFormat2Valid) && isAfter1900) ? null : { 'validDateFormat': true };
    }

    static validInputAutoComplete(control: AbstractControl): ValidationErrors | null {
        return null;
    }

    /**
     * Validates if valid date is entered using Native Date
     */
    static nativedate(control: AbstractControl): ValidationErrors | null {
        if (control.value === null || control.value === undefined || control.value === '') {
            return null;
          }
        const m = new Date(control.value);
        return !isNaN(m.valueOf()) ? null : { 'nativedate': true };
    }

    static datecheck(control: AbstractControl): ValidationErrors | null {
        const getdate = new Date(control.value);
        return getdate < new Date(2011, 11, 19) ? { 'datecheck': true } : null;
    }

    static datecheckCOB(control: AbstractControl): ValidationErrors | null {
        const getdateCOB = new Date(control.value);
        return getdateCOB < new Date(1982, 2, 31) ? { 'datecheckCOB': true } : null;
    }

    static datecheckCOBPension(control: AbstractControl): ValidationErrors | null {
        const getdateCOB = new Date(control.value);
        return getdateCOB < new Date(1981, 1, 1) ? { 'datecheckCOBPension': true } : null;
    }


    static doisocialsecurity(control: AbstractControl): ValidationErrors | null {
        const getdateCOB = new Date(control.value);
        return getdateCOB < new Date(2011, 1, 1) ? { 'doisocialsecurity': true } : null;
    }


    static valid(control: AbstractControl): ValidationErrors | null {
        const date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
        const regex_result = date_regex.test(control.value);
        return (!regex_result) ? { 'valid': true } : null;
    }

    /**
     * Validates if a date is before another
     */
    static dateLessThan(dateField1: string, dateField2: string, validatorField: { [key: string]: boolean }): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            const date1 = c.get(dateField1).value;
            const date2 = c.get(dateField2).value;
            if ((date1 !== null && date2 !== null) && new Date(date1).getTime() > new Date(date2).getTime()) {
                return validatorField;
            }
            return null;
        };
    }

    /**
     * Validates if a date is On or before another
     */
    static dateLessThanorEqual(dateField1: string, dateField2: string, validatorField: { [key: string]: boolean }): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            const date1 = c.get(dateField1).value;
            const date2 = c.get(dateField2).value;
            if ((date1 !== null && date2 !== null) && new Date(date1).getTime() >= new Date(date2).getTime()) {
                return validatorField;
            }
            return null;
        };
    }

    /**
    * Validates if a date is before another
    */
    static dateLessThanAGivenDate(dateField1: string, givenDate: Date, validatorField: { [key: string]: boolean }): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            const date1 = c.get(dateField1).value;
            if ((date1 !== null && givenDate !== null) && new Date(date1).getTime() < givenDate.getTime()) {
                return validatorField;
            }
            return null;
        };
    }

    /**
     * Validates if number entered is not zero
     */
    static notZero(control: AbstractControl): ValidationErrors | null {
        if ((control.value) === 0) {
            return { 'notZero': true };
        }
    }

    /**
     * Validates if number has a decimal value of 5
     */
    static pointFive(control: AbstractControl): ValidationErrors | null {
        if (control.value !== null) {
            const text = control.value.replace(/[^./\d]/g, '');
            const newNumber = parseFloat(text);
            if ((newNumber) % 1 !== 0) {
                if ((newNumber) % 1 !== 0.5) {
                    return { 'pointFive': true };
                }
            }
        }

    }

    static feinInvalid(control: AbstractControl): ValidationErrors | null {
        if (control.value != null) {
            const fein = control.value.replace(/[_-]/g, '');
            if (fein.length < 9) {
                return { 'invalidFein': true }; // minlength check
            } else if (isNaN(fein)) {
                return { 'invalidFein': true }; // numeric check
            } else {
                return null;
            }
        }
    }

    static zipCodeInvalid(control: AbstractControl): ValidationErrors | null {
        if (control.value != null) {
            const zipNumber = control.value.replace(/[_-]/g, '');
            const invalidZip = isNaN(zipNumber);

            if (invalidZip) {
                return { 'invalidZip': true };
            } else {
                if (![5, 9, 11].includes(zipNumber.length)) {
                    return { 'invalidZip': true };
                } else {
                    return null;
                }
            }
        }
    }

    static PhoneNumberValid(control: AbstractControl): ValidationErrors | null {
        if (control.value != null) {
            const phoneNumber = control.value.replace(/[^\d+]/g, '');
            const invalidPhone = isNaN(phoneNumber);
            if (invalidPhone) {
                return { 'invalidPhone': true };
            } else {
                if (![10].includes(phoneNumber.length)) {
                    return { 'invalidPhone': true };
                } else {
                    return null;
                }
            }
        }
    }

    //Docket Filing Number must begin with QF- and then have 6 to 12 characters of only numbers or hyphen
    static DocketFilingNumberValid(control: AbstractControl): ValidationErrors | null {
        const date_regex = /^QF-([0-9]|\-){6,12}$/;
        const regex_result = date_regex.test(control.value);
        return (!regex_result) ? { 'docketFilingNumberValid': true } : null;
    }

    static noSpace(control: AbstractControl): ValidationErrors | null {
        if (control.value != null) {
            const isWhitespace = (control.value.toString() || '').trim().length === 0;
            const isValid = !isWhitespace;
            return isValid ? null : { 'isValid': true };
        }
    }

    static validEmail(control: AbstractControl): ValidationErrors | null {
        if (control.value != null) {
       const isValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(control.value);
        return isValid ? null : { 'email': true };
    } return null;
    }


}


